import React from 'react';

import { PreQualificationStep, setPreQualificationStep } from 'actions';
import { AlreadyHaveActiveApplicationType } from 'enums/AlreadyHaveActiveApplicationType';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import useQueryParam, { useQueryParams } from 'hooks/useQueryParam';
import NotFoundContact from 'pages/NotFound/NotFoundContact';

import AcceptTermsOfUse from './steps/AcceptTermsOfUse';
import AlreadyHaveActiveApplication from './steps/AlreadyHaveActiveApplication';
import BorrowerIncome from './steps/BorrowerIncome';
import BorrowerInformation from './steps/BorrowerInformation';
import BorrowerPhoneVerification from './steps/BorrowerPhoneVerification';
import CoBorrowerIncome from './steps/CoBorrowerIncome';
import CoBorrowerInformation from './steps/CoBorrowerInformation';
import CoBorrowerPhoneVerification from './steps/CoBorrowerPhoneVerification';
import ContractorInfo from './steps/ContractorInfo';
import DeclinePage from './steps/DeclinePage/DeclinePage';
import LoanInformation from './steps/LoanInformation';
import NoOptions from './steps/NoOptions';
import NotAbleToAccept from './steps/NotAbleToAccept';
import RedirectToProveLink from './steps/RedirectToProveLink';
import UnfreezeCredit from './steps/UnfreezeCredit';
import LoanAmount from './steps/LoanAmount';

const getPageByStep = (step: PreQualificationStep | null, vfp?: string | null) => {
  switch (step) {
    case PreQualificationStep.LoanAmount:
      return <LoanAmount />;
    case PreQualificationStep.LoanInformation:
      return <LoanInformation />;

    case PreQualificationStep.TermsOfUse:
      return <AcceptTermsOfUse />;

    case PreQualificationStep.BorrowerPhoneVerification:
      return <BorrowerPhoneVerification />;

    case PreQualificationStep.CoBorrowerPhoneVerification:
      return <CoBorrowerPhoneVerification />;

    case PreQualificationStep.BorrowerInfo:
      return <BorrowerInformation />;

    case PreQualificationStep.CoBorrowerInfo:
      return <CoBorrowerInformation />;

    case PreQualificationStep.BorrowerIncome:
      return <BorrowerIncome />;

    case PreQualificationStep.CoBorrowerIncome:
      return <CoBorrowerIncome />;

    case PreQualificationStep.Contractor:
      return <ContractorInfo />;

    case PreQualificationStep.AlreadyHaveActiveApplication:
      return <AlreadyHaveActiveApplication pageType={AlreadyHaveActiveApplicationType.Borrower} />;

    case PreQualificationStep.BorrowerAsCoBorrowerAlreadyHaveActiveApplication:
      return <AlreadyHaveActiveApplication pageType={AlreadyHaveActiveApplicationType.BorrowerAsCoBorrower} />;

    case PreQualificationStep.CoBorrowerAlreadyHaveActiveApplication:
      return <AlreadyHaveActiveApplication pageType={AlreadyHaveActiveApplicationType.CoBorrower} />;

    case PreQualificationStep.NotAbleToAccept:
      return <NotAbleToAccept />;

    case PreQualificationStep.UnfreezeCredit:
      return <UnfreezeCredit />;

    case PreQualificationStep.NoOptions:
      return <NoOptions />;

    case PreQualificationStep.Decline:
      return <DeclinePage />;

    case PreQualificationStep.RedirectToProveLink:
      return <RedirectToProveLink vfp={vfp!} />;

    case PreQualificationStep.NotFoundContact:
      return <NotFoundContact />;

    default:
      return <LoanAmount />;
  }
};

const PreQualification = () => {
  const dispatch = useAppDispatch();

  const currentPreQualificationStep = useAppSelector((state) => state.stages.currentPreQualificationStep);
  const params = useQueryParams();
  const isFinishAuth = params.has('vfp');
  const vfp = useQueryParam('vfp');

  if (isFinishAuth) {
    dispatch(setPreQualificationStep(PreQualificationStep.RedirectToProveLink));
  }

  return getPageByStep(currentPreQualificationStep, vfp);
};

export default PreQualification;
